import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@prismicio/editor-ui"
import type { Editor } from "@tiptap/core"

import type { MenuItem } from "../models/MenuItems"

interface NodeItemsProps {
  items: MenuItem[]
  editor: Editor
}

export function NodeItems(props: NodeItemsProps) {
  const { items, editor } = props

  if (items.length === 0) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger disabled={items.length === 1}>
        <Button endIcon="arrowDropDown" size="small" color="grey">
          {items.find((item) => item.isActive(editor))?.text ?? ""}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        asPortal={false}
        maxHeight={256}
        avoidCollisions={false}
      >
        {items.map((item) => (
          <DropdownMenuItem
            key={item.nodeType}
            onSelect={() => {
              item.runCommands(editor)
            }}
          >
            {item.text}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
